
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.08)] w-full h-[560px]">
              <img
                src="https://public.readdy.ai/ai/img_res/d4c386c2e73d22deeab588685e206f38.jpg"
                alt="TMI Chrome Processing Facility Rustenburg"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#8B1538] text-white rounded-2xl p-6 shadow-xl">
              <div className="text-3xl font-bold font-['Montserrat']">8+</div>
              <div className="text-sm text-white/80 font-['Lato']">Years in Chrome</div>
            </div>
          </div>

          <div>
            <div className="inline-block bg-[#F5E6EA] text-[#8B1538] px-5 py-2 rounded-full text-sm font-semibold mb-6">
              ABOUT TMI
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-8 leading-tight font-['Montserrat']">
              Consultancy &amp; Commodity<br />Trading Excellence
            </h2>
            <div className="space-y-5 text-base text-[#5A6C7D] leading-relaxed font-['Lato']">
              <p>
                Tlotlo Mfolwe Incorporated is a consultancy and commodity trading entity registered in South Africa. Over 8 years, TMI has facilitated syndications and business linkages between buyers and sellers of various commodities, with a consolidated focus on <strong>chrome transactions and processing</strong>.
              </p>
              <p>
                TMI has acquired a processing plant in <strong>Rustenburg</strong> and beneficiates ROM (Run of Mine) into concentrate, selling directly to clients from the site. Currently the plant produces an average of <strong>1,000 MT of final product weekly</strong>, with plans to enhance output in the near future.
              </p>
              <p>
                Our management team brings over <strong>40 years of combined experience</strong> across legal, mining, property, financial, marketing, sales, and engineering sectors — backed by strategic partnerships that complement our in-house expertise.
              </p>
            </div>
            <Link
              to="/about"
              className="mt-8 inline-flex items-center gap-2 border-2 border-[#8B1538] text-[#8B1538] bg-transparent px-10 py-4 rounded-lg font-semibold hover:bg-[#8B1538] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Learn More About TMI
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
